import React from "react";

//MUI
import styled from "@emotion/styled";
import Dialog from '@mui/material/Dialog';
import Typography from "@mui/material/Typography";

const Container = styled("div")(({ theme }) => ({
  width: "100%",
  border: "1px solid #F3BF04",
  borderRadius: "6px",
  "& .text_info": {
    padding: "1.5rem 1rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "1rem",
    "& .text_style": {
      fontSize: "15px",
      color: "#1B1C1E",
      fontWeight: "500",
      [theme.breakpoints.down("xl")]: {
        fontSize: "14px",
      },
      [theme.breakpoints.down("lg")]: {
        fontSize: "13px",
      },
    },
  },
}));

const MessageDialog = (props) => {
  const { onClose, open, icon, message, linkText, onLinkClick, messageSuffix } =
    props;
  const Icon = icon;

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      fullWidth
      maxWidth={"md"}
      sx={{
        "& .MuiDialog-scrollPaper": {
          display: "flex",
          alignItems: "flex-start",
          borderRadius: "6px",
        },
        "& .MuiPaper-root": {
          borderRadius: "6px",
          border: "1px solid #F3BF04",
        }
      }}
    >
      <Container>
        <div className="text_info">
          {icon ? <Icon /> : <></>}
          <Typography className="text_style">
            {message}
            {linkText && (
              <span
                onClick={onLinkClick}
                style={{
                  color: "#00A0E3",
                  cursor: "pointer",
                  textDecoration: "underline",
                  fontWeight: 500,
                }}
              >
                {linkText}
              </span>
            )}
            {messageSuffix}
          </Typography>{" "}
        </div>
      </Container>
    </Dialog>
  );
};

export default MessageDialog;